import { useState } from 'react';
import React from 'react';

export function useHexMapControls() {
  const [zoom, setZoom] = useState(2);
  const [panOffset, setPanOffset] = useState({ x: 0, y: 0 });
  const [isPanning, setIsPanning] = useState(false);
  const [panStart, setPanStart] = useState({ x: 0, y: 0 });

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsPanning(true);
    setPanStart({ x: e.clientX - panOffset.x, y: e.clientY - panOffset.y });
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (isPanning) {
      setPanOffset({ x: e.clientX - panStart.x, y: e.clientY - panStart.y });
    }
  };

  const handleMouseUp = () => {
    setIsPanning(false);
  };

  const handleWheel = (e: React.WheelEvent) => {
    e.preventDefault();
    if (e.deltaY < 0) {
      setZoom(prev => Math.min(3, prev + 0.5));
    } else {
      setZoom(prev => Math.max(0.5, prev - 0.5));
    }
  };

  return {
    zoom, panOffset, isPanning,
    setZoom, setPanOffset,
    handleMouseDown, handleMouseMove, handleMouseUp, handleWheel,
  };
}
